import * as Yup from 'yup';

export const validationSchema: Yup.ObjectSchema<{}> = Yup.object().shape({
  recipientEmail: Yup.string().nullable().required('Please provide an email address.').email('Please use a valid email.')
});
